import { useEffect, useRef, useState } from "react";

export function useFonePay(rs) {
	const [status, setStatus] = useState("");

	// if the QR has expiry time, you can manage it here
	// const [expired, setExpired] = useState(false);
	const [verifiedRs, setVerifiedRs] = useState(null);
	const [paySuccessRs, setPaySuccessRs] = useState(null);

	const wsRef = useRef(null);

	useEffect(() => {
		if (!rs) return;
		if (!("WebSocket" in window)) {
			alert("WebSocket NOT supported!");
			return;
		}

		const ws = new WebSocket(rs.ThirdPartyQrWebSocketUrl);

		ws.onopen = function () {
			console.log("WebSocket Client Connected");
			setStatus("🔄 Awaiting payment...");
			wsRef.current = ws;
		}
		ws.onmessage = function (evt) {

			let wsMsg = evt.data;
			if (typeof wsMsg === 'string')
				wsMsg = JSON.parse(wsMsg);
			if (typeof wsMsg.transactionStatus === 'string')
				wsMsg.transactionStatus = JSON.parse(wsMsg.transactionStatus);
			let { success, message, qrVerified, paymentSuccess } = wsMsg.transactionStatus;
			if (success && qrVerified) {
				setVerifiedRs(wsMsg);
				setStatus("✅ QR Verified. Awaiting payment...");
			} else if (success && paymentSuccess) {
				setPaySuccessRs(wsMsg);
				setStatus("✅ Payment Successful");
			} else {
				paymentCancel(wsMsg);
			}
		};


		ws.onerror = function (evt) {
			console.log("WebSocket error: ", evt);
			setStatus("error: " + JSON.stringify(evt));
		}

		// const timer = setTimeout(() => {
		// 	setExpired(true);
		// 	setStatus("⏰ QR expired. Please regenerate.");
		// }, 300000);

		// return () => {
		// 	ws.close();
		// 	clearTimeout(timer);
		// };
	}, [rs]);



	return {
		status,
		//expired,
		verifiedRs,
		paySuccessRs,
	};
}
